import {useQuery} from "@tanstack/react-query";

import {vehiclesService} from "../services";

type UseAccountabilityParams = {
  vehicleId: number | null;
  householdId: number | null;
  enabled?: boolean;
};

export default function useAccountability({
  vehicleId,
  householdId,
  enabled = true,
}: UseAccountabilityParams) {
  const isEnabled = enabled && Boolean(vehicleId) && Boolean(householdId);
  const query = useQuery({
    queryKey: ["vehicles", "accountability", vehicleId, householdId],
    queryFn: () => vehiclesService.getAccountability(vehicleId!, householdId!),
    enabled: isEnabled,
    retry: false,
  });

  const accountability = query.isSuccess ? query.data : null;

  return {...query, accountability};
}
